import React from "react";
import { connect } from "react-redux";
import { MdChat, MdDashboard } from "react-icons/md";
import ServiceMenu from "./components/ServiceMenu";
import StatusInfo from "./components/StatusInfo";
import CrudButtons from "components/button/crudbuttons";
import { displayIcon } from "variables/icons";
import { useNavigate } from "react-router-dom";
import Button from "components/button";

const Services = ({user}) => {

  const navigate = useNavigate();
  
  const handleHomeClick = () => {
    navigate(`/panel/main-services`);
  };

  return (
    <div className="mb-16 grid grid-cols-1 gap-5 max-w-[700px] mx-auto">
      <div className="dark:bg-intsamis-900 text-right my-3">
        <button onClick={handleHomeClick}
          type="button"
          className="flex items-center gap-3 rounded-xl bg-green-700 px-10 py-4 text-base font-medium text-white shadow-sm transition hover:bg-green-800"
        >
          {displayIcon("House")} 
          Home
        </button>
      </div>

      <ServiceMenu
          icon={<MdDashboard className="h-7 w-7" />}
          title={"Farmer Information"}
          to="/panel/my-farmer-information"
          infoNav={<StatusInfo status={user?.user_details?.certify_status_name}/>}
      />
      {user?.user_details?.is_validated && 
      <ServiceMenu
          icon={<MdDashboard className="h-7 w-7" />}
          title={"Register Animals"}
          to="/panel/my-registered-animals"
      />
      }
      {/* <ServiceMenu
          icon={<MdDashboard className="h-7 w-7" />}
          title={"Service 3"}
          to="/panel/service-3"
      /> */}
      <ServiceMenu
          icon={<MdChat className="h-7 w-7" />}
          title={"Chat Support"}
          to="/panel/chat-support"
      /> 

      
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Services);